import React, { useEffect, useState } from 'react';
import SelectAsyncComponent from '../../../componentes/select/select-async.component';
import {
	Row,
	Col,
	FormGroup,
	Label,
	Input,
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
	Button,
} from 'reactstrap';
import SelectCreatableComponent from '@componentes/select/select-creatable.component';
import IntlMessage from '../../../helpers/intlMessage';
import { useIntl } from 'react-intl';
import { httpRequest } from '@util/api-common.util';
import WebapiCommon from '@util/webapi.common';

const HistologiaBlocosEdit = (props) => {
	const intl = useIntl();
	const [anotacoes, setAnotacoes] = useState('');
	const [complementos, setComplementos] = useState([]);
	const [complementoSelecionado, setComplementoSelecionado] = useState(null);
	const [patologistas, setPatologistas] = useState([]);
	const [patologistaSelecionado, setPatologistaSelecionado] = useState(null);

	useEffect(() => {
		WebapiCommon.listarComplemento('HISTOLOGIA_TECNICA').then((res) => {
			setComplementos(res);
			res.filter((complemento) => {
				if (props.blocoSelecionado.complemento === complemento.label) {
					setComplementoSelecionado(complemento);
				}
			});
		});

		WebapiCommon.getMedicos().then((res) => {
			setPatologistas(res);
			res.filter((patologista) => {
				if (props.blocoSelecionado.medicoId === patologista.value) {
					setPatologistaSelecionado(patologista);
				}
			});
		});

		props.blocoSelecionado && props.blocoSelecionado.observacao
			? setAnotacoes(props.blocoSelecionado.observacao)
			: setAnotacoes('');
	}, [props.blocoSelecionado]);

	const handleCreateSelectCreatable = (value) => {
		const etapa = 'HISTOLOGIA_TECNICA';
		WebapiCommon.cadastrarComplemento(etapa, value).then(() => {
			WebapiCommon.listarComplemento(etapa).then(res => {
				res.filter((complemento) => {
					if (value === complemento.label) {
						setComplementoSelecionado(complemento);
					}
				});

				setComplementos(res);
			});
		});
	};

	const editarLamina = () => {
		const url =
			props.blocoSelecionado.tipoLamina === undefined
				? 'Cassetes/alterar-dados-cassete'
				: 'lamina/alterar-dados-lamina';
		const body = {
			id: props.blocoSelecionado.id,
			idLamina: props.blocoSelecionado.id,
			observacao: anotacoes,
			complemento: complementoSelecionado.label,
			medicoId: patologistaSelecionado ? patologistaSelecionado.value : 0,
			laudo: props.blocoSelecionado.cdLaudo,
		};

		httpRequest(url, 'PATCH', body).then((res) => {
			props.commonActions.showAlerta(
				'sucesso',
				'Lâmina editada com sucesso!',
				1500
			);
			props.openModalBlocos();
			props.buscar();
		});
	};

	const limparCampos = () => {
		setPatologistaSelecionado({});
		setComplementoSelecionado(null);
		setAnotacoes('');
	};

	function translate(key) {
		return intl.formatMessage({ id: key });
	}
	return (
		<Modal
			isOpen={props.modalHistologiaBlocos}
			toggle={props.openModalBlocos}
			size="lg"
		>
			<div className="citologia-modal-page">
				<ModalHeader toggle={props.toggle}>
					<IntlMessage id="dashboards.examDetail.table.editComplement" />
				</ModalHeader>
				<ModalBody>
					<Row>
						<Col>
							<FormGroup>
								<Label>
									<IntlMessage id="dashboards.examDetail.bladeAddOn" />
								</Label>
								<SelectCreatableComponent
									onChange={(ev) => setComplementoSelecionado(ev)}
									options={complementos}
									onCreateOption={handleCreateSelectCreatable}
									placeholder={translate('dashboards.examDetail.selectBladeAddOn')}
									value={complementoSelecionado}
								/>
							</FormGroup>
						</Col>
					</Row>
					<Row>
						<Col>
							<FormGroup>
								<Label>
									<IntlMessage id="dashboards.examDetail.annotations" />
								</Label>
								<Input
									type="textarea"
									maxLength={300}
									onChange={(ev) => setAnotacoes(ev.target.value)}
									value={anotacoes}
								/>
							</FormGroup>
						</Col>
					</Row>
					<Row>
						<Col>
							<FormGroup>
								<Label>
									<IntlMessage id="dashboards.cytology.pathologist" />
								</Label>
								<SelectAsyncComponent
									options={patologistas}
									value={patologistaSelecionado}
									placeholder={translate(
										'dashboards.examDetail.selectPathologist'
									)}
									onChange={(ev) => {
										setPatologistaSelecionado(ev);
									}}
								/>
							</FormGroup>
						</Col>
					</Row>
				</ModalBody>
				<ModalFooter className="paddingTop-none">
					<Button color="danger" onClick={limparCampos}>
						<IntlMessage id="dashboards.examDetail.clearFields" />
					</Button>
					<Button color="secondary" onClick={props.openModalBlocos}>
						<IntlMessage id="dashboards.examDetails.cancel" />
					</Button>
					<Button color="primary" onClick={editarLamina}>
						<IntlMessage id="general.materialArchiving.save" />
					</Button>
				</ModalFooter>
			</div>
		</Modal>
	);
};
export default HistologiaBlocosEdit;



// WEBPACK FOOTER //
// ./src/pages/histologia/laminas/blocos.edit.modal.page.js